import { ChangeDetectionStrategy, Component } from "@angular/core";

@Component({
  selector: "app-loading",
  imports: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
  styles: [
    `
      .spinner {
        width: 70px;
        text-align: center;
      }

      .spinner > div {
        display: inline-block;
        width: 18px;
        height: 18px;
        -webkit-animation: sk-bouncedelay 1.4s infinite ease-in-out both;
        animation: sk-bouncedelay 1.4s infinite ease-in-out both;
        border-radius: 100%;
        background-color: #aaa;
      }

      .spinner .bounce1 {
        -webkit-animation-delay: -0.32s;
        animation-delay: -0.32s;
      }

      .spinner .bounce2 {
        -webkit-animation-delay: -0.16s;
        animation-delay: -0.16s;
      }

      @-webkit-keyframes sk-bouncedelay {
        0%,
        80%,
        100% {
          -webkit-transform: scale(0);
        }
        40% {
          -webkit-transform: scale(1);
        }
      }

      @keyframes sk-bouncedelay {
        0%,
        80%,
        100% {
          -webkit-transform: scale(0);
          transform: scale(0);
        }
        40% {
          -webkit-transform: scale(1);
          transform: scale(1);
        }
      }
    `,
  ],
  template: `
    <div class="spinner" aria-label="loading">
      <div class="bounce1"></div>
      <div class="bounce2"></div>
      <div class="bounce3"></div>
    </div>
  `,
})
export class LoadingComponent {}
